import api from "./api";

// ======================
// Experience
// ======================
export const moveExperienceUp = (id) =>
  api.patch(`/experiences/${id}/up`);

export const moveExperienceDown = (id) =>
  api.patch(`/experiences/${id}/down`);

export const getExperiences = () =>
  api.get("/experiences");

export const createExperience = (data) =>
  api.post("/experiences", data);

export const updateExperience = (id, data) =>
  api.put(`/experiences/${id}`, data);

export const deleteExperience = (id) =>
  api.delete(`/experiences/${id}`);